import { useState, useContext, useEffect } from "react";
import {
	Container,
	Group,
	Image,
	Button,
	Modal,
	TextInput,
} from "@mantine/core";
import ExperienceContext from "./ExperienceContext";
import hotspotIcon from "../../static/svg/panorama.svg";
import { CDN_URL } from "../../constant";

function PanoSpotControls({ activePanoId, selectedObject, closeControls }) {
	const [name, setName] = useState(selectedObject.name);
	const [isViewOpen, setIsViewOpen] = useState(false);
	const { changePanoSpotName, deletePanoSpot } =
		useContext(ExperienceContext);

	useEffect(() => {
		setName(selectedObject.name);
	}, [selectedObject]);
	return (
		<>
			<Group
				style={{
					height: "96px",
					width: "340px",
					backgroundColor: "#040f1fcc",
					padding: "10px 20px 10px 20px",
					borderRadius: "5px",
				}}
			>
				<Container
					px={0}
					mx={0}
					style={{
						backgroundColor: "#00000099",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						width: "50px",
						height: "50px",
						borderRadius: "50px",
					}}
				>
					<Image src={hotspotIcon} alt="Hotspot" width="25px" />
				</Container>
				<Container px={0} mx={0} style={{ width: "230px" }}>
					<Group direction="column" spacing={10}>
						<TextInput
							label="Name:"
							size="xs"
							styles={{
								root: {
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									width: "100%",
									color: "#A4BAC6",
								},
								label: {
									paddingLeft: "5px",
									paddingRight: "10px",
									fontSize: "14px",
									color: "#A4BAC6",
								},
								input: { backgroundColor: "#040F1F" },
							}}
							value={name}
							onChange={(event) => {
								setName(event.currentTarget.value);
								changePanoSpotName(
									activePanoId,
									selectedObject.id,
									event.currentTarget.value
								);
							}}
						/>
						<Group
							direction="row"
							style={{
								justifyContent: "space-between",
								alignItems: "center",
								width: "100%",
							}}
						>
							<Button
								variant="outline"
								size="xs"
								radius={"sm"}
								py={5}
								style={{
									fontWeight: "normal",
									fontSize: "14px",
									color: "#ffffff",
									borderColor: "#4dabf7",
								}}
								onClick={() => {
									setIsViewOpen(true);
								}}
							>
								View Image
							</Button>
							<Button
								variant="outline"
								size="xs"
								radius={"sm"}
								py={5}
								style={{
									fontWeight: "normal",
									fontSize: "14px",
									color: "#ffffff",
									backgroundColor: "#e03131",
									borderColor: "#e03131",
								}}
								onClick={() => {
									closeControls();
									deletePanoSpot(
										activePanoId,
										selectedObject.id
									);
								}}
							>
								Delete
							</Button>
						</Group>
					</Group>
				</Container>
			</Group>
			<Modal
				centered
				size="lg"
				opened={isViewOpen}
				onClose={() => setIsViewOpen(false)}
				title={selectedObject.name}
				styles={{
					modal: { backgroundColor: "#040F1F" },
					title: { color: "#ffffff", fontWeight: "700" },
				}}
			>
				<Image src={CDN_URL + selectedObject.url} fit="cover" />
			</Modal>
		</>
	);
}

export default PanoSpotControls;
